/**
 * forbiddenHedges — WRAPPER-DISCIPLINE-EXT-1
 *
 * Default list of forbidden hedge phrases for declarative-context outputs.
 * Tenant-overridable via Firestore tenants/{tid}/cognition_config/forbidden_hedges
 * (loaded by the wrapper, passed as hedgeList to hedgeDetector).
 *
 * Default phrases are LOCKED. Tenant overrides are additive (union with defaults)
 * unless the tenant explicitly sets replaceDefaults: true.
 */

export const DEFAULT_FORBIDDEN_HEDGES = [
  'arguably',
  'one might say',
  'it could be argued',
  'it can be argued',
  'some would say',
  'some might argue',
  'in some sense',
  'in a way',
  'to some extent',
  'perhaps',
  'it is possible that',
  'it seems possible',
  'one could make the case',
  'there is a case to be made',
  'it might be said',
  'many would argue',
  'you could argue',
  'this is debatable',
  'it is debatable',
  'open to interpretation',
  'some might suggest',
  'it could reasonably be said',
  'not everyone would agree',
];

/**
 * Merge tenant hedge config with defaults.
 *
 * @param {{ phrases?: string[], replaceDefaults?: boolean }|null} tenantConfig
 * @returns {string[]}
 */
export function resolveHedgeList(tenantConfig = null) {
  if (!tenantConfig || !Array.isArray(tenantConfig.phrases)) {
    return DEFAULT_FORBIDDEN_HEDGES;
  }
  if (tenantConfig.replaceDefaults === true) {
    return tenantConfig.phrases;
  }
  const merged = new Set([...DEFAULT_FORBIDDEN_HEDGES, ...tenantConfig.phrases]);
  return Array.from(merged);
}
